<app-slide-in-right-modal
  modalTitle="Attach account to profile"
  [slideOpen]="true"
  [returnPath]="returnPathUrl"
  iconImageSrc="assets/images/svgs/user--outline.svg"
>
  <div class="page__container flex flex-col pb-8">
    <form class="flex flex-col gap-5 px-0" [formGroup]="accountTypeForm">
      @if (isCorporate) {
        <div>
          <app-input-label labelFor="signatory" labelClass="label--bottom-margin"
            >Signatory</app-input-label
          >
          <select id="signatory" name="profileId" required base-select formControlName="profileId">
            <option value="" disabled selected>Select signatory to own the account</option>
            @for (s of signatories; track s.signatory_id) {
              <option [value]="s.user.id">{{ s.user.first_name }} {{ s.user.last_name }} ({{ s.user.email }})</option>
            }
          </select>
        </div>
      }
      <!-- Account Type -->
      <div>
        <app-input-label labelFor="first-name" labelClass="label--bottom-margin"
          >Account Type</app-input-label
        >
        <select
          name="accountType"
          required
          base-select
          formControlName="accountType"
        >
          <option value="" disabled selected>Select account type to attach</option>
          <option [value]="'individual'"> Individual</option>
          <option [value]="'corporate'"> Corporate</option>
          <option [value]="'joint'"> Joint</option>
        </select>
      </div>

        <button
            mango-button
            (click)="attachAccount()"
            [disabled]="isLoading || accountTypeForm.invalid"
            class="w-full justify-center xl:col-start-2 xl:w-fit xl:justify-self-end"
            >

            @if (isLoading) {
              <span spin></span>
            } @else {
                Attach Account
            }
    
        </button>

    </form>
  </div>
</app-slide-in-right-modal>
